import { bootstrapApplication } from '@angular/platform-browser';
import { appConfigClient } from './app/configs/app.config.client';
import { AppComponent } from './app/app.component';


bootstrapApplication(AppComponent, appConfigClient)
  .catch((err) => console.error(err));
